<div class="errwrap">
  <div class="errdiv1" id="errs"></div>
</div>
<div *ngIf="actionmode=='Add' || actionmode=='Edit'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title">{{screentitle}}</h1>

      <div class="button-wrapper bothbuttdiv2">
        <div *ngIf="actionmode=='Add' || actionmode=='Edit'" class="btn back-button button-margin">
          <button *ngIf="IsDisable" class="btn btn-primary commonbutt" type="button" (click)="submitdata()">
            <em class="fa fa-check"></em>&nbsp;Submit
          </button>
          <button class="btn btn-primary commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close</button>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div style="padding: 2% 2% 2% 2%">
                  <div class="col-lg-3">
                    <label>Functionality Name</label>
                    <input type="text" placeholder="enter the fun_name" class="form-control m-input"
                      [(ngModel)]="functionality_screen_details.FUN_NAME" [disabled]="showList==true">
                  </div>
                  <div class="col-lg-3">
                    <label>Route Name</label>
                    <input type="text" placeholder="enter the fun_router_name" class="form-control m-input"
                      [(ngModel)]="functionality_screen_details.FUN_ROUTER_NAME" [disabled]="showList==true">
                  </div>
                  <div class="col-lg-3">
                    <label>Parent Class</label>
                    <select id="fun_id" class="form-control m-input"
                      [(ngModel)]="functionality_screen_details.FUN_PARENT" [disabled]="showList==true">
                      <option disabled value="0">--Select--</option>
                      <option value="{{combo.FUN_ID}}" *ngFor="let combo of combo_details1;">{{combo.FUN_NAME}}</option>
                    </select>
                  </div>

                  <div class="col-lg-3">
                    <label>Functionality Status</label>
                    <select class="form-control m-input" [(ngModel)]="functionality_screen_details.FUN_STATUS"
                      [disabled]="showList==true">
                      <option value="{{item.key}}" *ngFor="let item of Functionality_Status;">{{item.value}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="myModal" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="padding:20px 50px;">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="modal-title">
          <span class="glyphicon glyphicon-thumbs-up"></span>Aprove Request
        </h4>
      </div>

      <div class="modal-body">
        <div class="col-lg-13">
          <label> Remarks</label>
          <textarea [(ngModel)]="aprove_details.APPROVAL_REMARKS" rows="8" cols="20" type="text"
            class="form-control m-input" placeholder="Enter  Remarks"> </textarea>
          <span *ngIf="aprove_details.APPROVAL_REMARKS==''" class="m-form__help" style="color: red">Please enter
            Remarks</span>

        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-success " type="button" (click)="aproveReject(1)" data-dismiss="modal">
          <em class="fa fa-check "></em>&nbsp;&nbsp;
          <span class="bold">Approve</span>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- ########## -->

<!-- ########## -->
<div class="modal fade" id="myModal2" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="padding:20px 50px;">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="modal-title">
          <span class="glyphicon glyphicon-thumbs-down"></span>Reject Request
        </h4>
      </div>
      <div class="modal-body">
        <div class="col-lg-13">
          <label>Remarks</label>
          <textarea [(ngModel)]="aprove_details.APPROVAL_REMARKS" rows="8" cols="20" type="text"
            class="form-control m-input" placeholder="Enter  Remarks"> </textarea>
          <span *ngIf="aprove_details.APPROVAL_REMARKS==''" class="m-form__help" style="color: red">Please enter
            Remarks</span>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-warning " type="button" (click)="aproveReject(2)" data-dismiss="modal">
          <em class="fa fa-check "></em>&nbsp;&nbsp;
          <span class="bold">Reject</span>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- ########## -->


<div *ngIf="actionmode!='Add' && actionmode!='Edit'" class="searchdiv">
  <div class="headerdiv">
    <h1>
      Functionality Search
    </h1>
    <div class="bothbuttdiv">
      <button class="btn btn-primary commonbutt" type="button" *ngIf="RAC_ADD =='1'" (click)="addForm()">
        <em class="fa fa-plus-circle"></em>&nbsp;Add New</button>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-div">
          <div class="row">
            <div class="m-portlet">
              <div style="padding: 2% 4% 2% 2%">
                <div>
                  <div>

                    <div class="col-lg-3">
                      <label>Functionality Name</label>
                      <input type="text" placeholder="enter the fun_name" class="form-control m-input"
                        [(ngModel)]="functionality_search_details.fun_name">
                    </div>
                    <div class="col-lg-3">
                      <label>Functionality Route Name</label>
                      <input type="text" placeholder="enter the fun_router_name" class="form-control m-input"
                        [(ngModel)]="functionality_search_details.fun_router_name">
                    </div>
                  </div>
                  <div class="btn clear-button button-margin">
                    <button style="margin-top: 20px;" class="btn btn-primary commonbutt" (click)="searchData()"
                      type="button">
                      <em class="fa fa-search "></em>&nbsp;Search</button>
                  </div>
                </div>
                <div style="padding: 2% 4% 2% 2%" [hidden]="searchlist">
                  <table aria-describedby="searchDetails" class="table table-striped" [mfData]="serachtabledata"
                    *ngIf="!loader" [mfRowsOnPage]="5">
                    <thead>
                      <tr>
                        <th scope="col" style="width: 20%" *ngIf="RAC_VIEW =='1' && RAC_EDIT =='1'">
                          Actions
                        </th>

                        <th scope="col" style="width: 50%">

                          <mfDefaultSorter by="email">Functionality Name</mfDefaultSorter>
                        </th>

                        <th scope="col" style="width: 50%">

                          <mfDefaultSorter by="email">Route Name</mfDefaultSorter>
                        </th>

                        <th scope="col" style="width: 50%">

                          <mfDefaultSorter by="email">Funtionality Parent Id</mfDefaultSorter>
                        </th>

                        <th scope="col" style="width: 50%">

                          <mfDefaultSorter by="email">Funtionality Status</mfDefaultSorter>
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of serachtabledata | paginate: { itemsPerPage: 10, currentPage: p }">
                        <td *ngIf="RAC_VIEW =='1' && RAC_EDIT =='1'">
                          <button class="btn btn-default btn-circle" *ngIf="RAC_VIEW =='1'" type="button"
                            (click)="showFormData(item.FUN_ID,1)">
                            <em class="fa fa-eye"></em>
                          </button>
                          <button class="btn btn-default btn-circle" *ngIf="RAC_EDIT =='1'" type="button"
                            (click)="showFormData(item.FUN_ID,2)">
                            <em class="fa fa-pencil"></em>
                          </button>
                        </td>
                        <td>{{item.second}}</td>
                        <td>{{item.FUN_ROUTER_NAME}}</td>
                        <td>{{item.first}}</td>
                        <td>{{item.FUN_STATUS}}</td>
                      </tr>


                    </tbody>
                    <pagination-controls (pageChange)="p = $event"></pagination-controls>
                    <tfoot>
                      <tr>
                        <td colspan="4">

                        </td>
                      </tr>
                    </tfoot>
                  </table>


                </div>
                <div *ngIf="loader">
                  <div style="margin:auto; text-align: center">
                    <img
                      src="https://vignette.wikia.nocookie.net/lego/images/b/b4/Loading_Animation.gif/revision/latest/scale-to-width-down/480?cb=20120528032206"
                      width="20%" height="20%" alt="Loader">
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>